var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0782 16.5937C13.2501 16.7499 13.5157 16.7343 13.672 16.5625C13.8282 16.3906 13.8126 16.1249 13.6407 15.9687L7.59384 10.5C7.43759 10.3593 7.43759 10.1562 7.59384 10.0156L13.6407 4.73433C13.8126 4.57808 13.8282 4.31245 13.6876 4.14058C13.5313 3.9687 13.2657 3.95308 13.0938 4.0937L7.04696 9.39058C6.51571 9.85933 6.50009 10.6406 7.03134 11.125L13.0782 16.5937Z",
    fill: "#45728B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.46cdf86eedd79c000dbf38abc387e7b0.svg";
export { ForwardRef as ReactComponent };